import React, { Component } from "react";
import { connect } from "react-redux";
import {Alert,Col,Row,Rate,Icon,Tooltip,Button,Popover,Badge,Menu,	Dropdown,Modal,Input,Spin} from "antd";
import moment from "moment";
import {PossWarrantyIcon,RubleIcon,UrgentIcon,BadWorkIcon,WarrantyIcon,RetryIcon,RecordIcon,AttachIcon,UserMobileIcon,} from "../resource/icons";
import RecordsPanelContainer from "../containers/records-panel.container";
import AttachmentsPanelContainer from "../containers/attachments-panel.container";
import { authHeader } from "../helpers/auth-header";
import { dspxDiffDays, declOfNum } from "../helpers/dspx-utils";
import { client } from "../actions/";
import { requestListActions } from "../containers/Requests/request-list.actions";
import warrantyActions from "../actions/warranty.actions";
import executeTimeActions from "../actions/execute-time.actions";
import serviceActions from "../actions/service.actions";
import addressActions from "../actions/address.actions";
import { actions as newRequestAction } from "../containers/CreateRequest/new-request.actions";
import NotesPanelContainer from "../containers/notes-panel.container";
import WarrantyPanel from "../containers/warranty-panel";
import MarksPanel from "./marks-panel";
import { openModalAlertDate } from "../actions/alert-date.actions";

const confirm = Modal.confirm;

class DspxRequest extends Component {
	constructor(props) {
		super(props);

		this.state = {
			statuses: [],
			marksPanelVisibleId: 0,
			descriptionPanelVisibleId: 0,
			descriptionPanelValue: "",
			attachementPanelVisible: 0,
		};
	}

	fetchStatuses = async () => {
		let rurl = "/Request/statuses_for_set";
		const res = await client.get(rurl, { headers: authHeader() });
		const sts = res.data;
		await sts.sort((a, b) => a.orderNum - b.orderNum);
		return sts;
	};

	handleCalendarClick = (val, data) => {
		val.stopPropagation();
		this.props.dispatch(executeTimeActions.openCalendarModal(data));
	};

	handleChangeStatusClick = (val) => {
		val.domEvent.stopPropagation();

		if (val.key == 8) {
			this.handleSetStatusClick({
				rid: val.item.props.rid,
				newStatus: val.key,
				newStatusDescription:
					this.state.statuses[val.item.props.index].description,
			});
		} else {
			confirm({
				title: "Изменить статус заявки?",
				content: (
					<div>
						Заявка: <strong>{val.item.props.rid}</strong>
						<br />
						Новый статус:{" "}
						<strong>
							{this.state.statuses[val.item.props.index].description}
						</strong>
					</div>
				),

				onOk: () => {
					this.props.dispatch(
						requestListActions.setRequestStatus(
							val.item.props.rid,
							val.key,
							this.state.statuses[val.item.props.index].description
						)
					);
				},
				onCancel: () => {
					console.log("Cancel");
				},
			});
		}
	};

	handleSetStatusClick = ({ rid, newStatus, newStatusDescription }) => {
		this.props.dispatch(
			executeTimeActions.openExecuteTimeModal({
				rid,
				newStatus,
				newStatusDescription,
			})
		);
	};

	handleChangeWarrantyClick = (val) => {
		val.domEvent.stopPropagation();

		this.props.dispatch(
			warrantyActions.openWarrantyModal(val.item.props.rid, val.key)
		);
	};

	handleWarrantyClick = (val) => {
		val.stopPropagation();
		const rid = val.target.getAttribute('rid');

		confirm({
			title: 'Перевести заявку в обычные?',
			content:
				<div>
					Заявка: <strong>{rid}</strong></div>,

			onOk: () => {
				this.props.dispatch(warrantyActions.setPossWarranty(rid, 0));
			},
			onCancel: () => {},
		})
	}

	handlePossWarrantyClick = (val) => {
		const rid = val.target.getAttribute('rid');

		confirm({
			title: 'Перевести заявку в возможно гарантийные?',
			content:
				<div>
					Заявка: <strong>{rid}</strong></div>,

			onOk: () => {
				this.props.dispatch(warrantyActions.setPossWarranty(rid, 2));
			},
			onCancel: () => {
				console.log(rid);
			},
		})
	}

	handleServiceClick = (val) => {
		val.stopPropagation();
		this.props.dispatch(
			serviceActions.openServiceModal(
				val.target.getAttribute("rid"),
				val.target.getAttribute("parent_service"),
				val.target.getAttribute("parent_service_id"),
				val.target.getAttribute("service_id"),
				val.target.getAttribute("house_id")
			)
		);
	};

	handleExecuteDateClick = (val) => {
		val.stopPropagation();
		this.props.dispatch(
			executeTimeActions.openExecuteTimeModal({rid: val.target.getAttribute('rid')})
		);
	};

	handleAddressClick = (record, serviceOnly) => {
		this.props.dispatch(newRequestAction.setRequestId(record.id));
		this.props.dispatch(newRequestAction.applyAddrStreet(record.streetId));
		this.props.dispatch(
			newRequestAction.applyAddrBuilding(record.houseId, record.serviceId)
		);
		this.props.dispatch(newRequestAction.setAddrFlatValue(record.addressId));
		this.props.dispatch(newRequestAction.applyService(record.parentServiceId));
		this.props.dispatch(newRequestAction.setSubserviceValue(record.serviceId));
		this.props.dispatch( newRequestAction.applyPossWarranty(record.garantyId>0));
		this.props.dispatch(
			newRequestAction.setWorkerValue(record.master && record.master.id)
		);
		this.props.dispatch(
			newRequestAction.setExecuterValue(record.executer && record.executer.id)
		);
		const r = { ...record, serviceOnly: serviceOnly };
		this.props.dispatch(addressActions.openAddressModal(r));
	};

	handleExecuterClick = (val, record) => {
		val.stopPropagation();
		const param = { 
			houseId: record.houseId, 
			serviceId: record.serviceId, 
			possWarranty: record.garantyId>0, 
			requestId: record.id 
		};

		this.props.dispatch(newRequestAction.fetchExecuterList(param))

		this.props.dispatch(
			executeTimeActions.openExecuterModal(record.id+'', record.executer && record.executer.id+'' ));
	};

	handleMasterClick = (val, record) => {
		val.stopPropagation();
		const param = { 
			houseId: record.houseId, 
			serviceId: record.serviceId, 
			possWarranty: record.garantyId>0, 
			requestId: record.id
		}

		this.props.dispatch(
			newRequestAction.fetchWorkerList(param)
		);

		this.props.dispatch(
			executeTimeActions.openMasterModal( record.id+'', record.master && record.master.id+'', ));
	};

	handleAttachementClick = (requestId) => {
		this.setState((state, props) => {
			return {
				attachementPanelVisible:
					state.attachementPanelVisible == requestId ? 0 : requestId,
			};
		});
	};

	handleAttachementPanelVisibleChange = (visible) => {
		if (visible) return;
		this.setState((state, props) => {
			return {
				attachementPanelVisible: !(props.showPreview || props.showModal)
					? 0
					: state.attachementPanelVisible,
			};
		});
	};

	handleRatingClick = (e) => {
		e.stopPropagation();
	};

	handleRatingChange = (v, rid, ov) => {
		if (!v) return;

		const t = v ? (
			ov > 0 ? (
				<span>
					Изменить оценку с: <strong>{ov}</strong> на <strong>{v}</strong>?
				</span>
			) : (
				<span>
					Поставить оценку: <strong>{v}</strong>?
				</span>
			)
		) : (
			<span>Удалить оценку?</span>
		);

		confirm({
			title: "Изменить оценку заявки?",
			content: (
				<div>
					Заявка: <strong>{rid}</strong>
					<br />
					{t}
				</div>
			),

			onOk: () => {
				this.props.dispatch(requestListActions.setRequestRating(rid, v, false));
			},
			onCancel: () => {
				//this.props.dispatch(requestListActions.setRequestRating(rid, ov, false));
			},
		});
	};

	componentDidMount() {
		this.fetchStatuses().then(
			(data) => {
				this.setState({ statuses: data });
			},
			(err) => {
				console.log(err);
			}
		);

		//  this.props.dispatch(requestsActions.fetchRequests(this.props.requestId));
	}

	handleStateClick = (e) => {
		e.stopPropagation();
	};

	handleMarksPanelVisibleChange = (rid, visible) => {
		this.setState({ marksPanelVisibleId: visible ? rid : 0 });
	};

	handlePostComment = rid => {
		this.props.dispatch(requestListActions.markRequestCommented(rid));
	}

	// handleOnClearAlertDate = (rid) => {
	// 	this.setState({ marksPanelVisibleId : 0 })		

	// 	confirm({
	// 		title: 'Очистить поле "Дата контроля"?',
	// 		onOk: () => {
	// 			this.props.dispatch( requestListActions.setRequestControlDate( { requestId: rid, date: null }));
	// 		},
	// 		onCancel: () => {
	// 			console.log('Cancel');
	// 		},
	// 	})
	// }

	handleOnChangeImmediate = (rid, e, record) => {
		this.setState({ marksPanelVisibleId: 0 });

		confirm({
			title: "Изменить признак заявки?",
			content: (
				<div>
					Заявка: <strong>{rid}</strong>
					<br />
					{e ? "Установить" : "Снять"} признак <strong>Аварийная</strong>
				</div>
			),

			onOk: () => {
				// if(!e) {
				// 	this.props.dispatch( requestListActions.setRequestMark( rid, 'immediate', e ? 1 : 0));
				// 		this.handleOnClearAlertDate(rid);
				// 		return
				// 	}
				
				// if(!record?.alertDateTime) {
				// 	this.props.dispatch(openModalAlertDate({data: record, isRequestForImmediate: true}));
				// 	return;
				// }

				this.props.dispatch( requestListActions.setRequestMark( rid, 'immediate', e ? 1 : 0));
			},
			onCancel: () => {
				console.log("Cancel");
			},
		});
	};

	handleOnChangeChargeable = (rid, e) => {
		this.setState({ marksPanelVisibleId: 0 });
		confirm({
			title: "Изменить признак заявки?",
			content: (
				<div>
					Заявка: <strong>{rid}</strong>
					<br />
					{e ? "Установить" : "Снять"} признак <strong>Платная</strong>
				</div>
			),

			onOk: () => {
				this.props.dispatch(
					requestListActions.setRequestMark(rid, "chargeable", e ? 1 : 0)
				);
			},
			onCancel: () => {
				console.log("Cancel");
			},
		});
	};

	handleDescriptionPanelVisibleChange = (rid, des, visible) => {
		this.setState({
			descriptionPanelVisibleId: visible ? rid : 0,
			descriptionPanelValue: visible ? des : "",
		});
	};

	handleDescriptionPanelOk = () => {
		this.setState({ descriptionPanelVisibleId: 0 });
		if (this.state.descriptionPanelValue)
			this.props.dispatch(
				requestListActions.setRequestDescription(
					this.state.descriptionPanelVisibleId,
					this.state.descriptionPanelValue
				)
			);
	};

	handleDescriptionPanelCancel = () => {
		this.setState({ descriptionPanelVisibleId: 0 });
	};

	handleDescriptionPanelChange = (v) => {
		this.setState({ descriptionPanelValue: v.target.value });
	};

	render() {
		if ((!Array.isArray(this.props.requests) || !this.props.requests[0]) && !this.props.dataFetching)
			return <Alert message={this.props.requests} type="error" showIcon />;

		const record = this.props.request || this.props.requests[0];

		const DescriptionPanel = (
			<div style={{ textAlign: "right", width: "360px" }}>
				<Input.TextArea
					onChange={this.handleDescriptionPanelChange}
					value={this.state.descriptionPanelValue}
					type="textarea"
					autoSize={{ minRows: 2, maxRows: 5 }}
					style={{ marginBottom: "10px" }}
				/>
				<Button
					onClick={this.handleDescriptionPanelCancel}
					style={{ marginRight: "10px" }}
				>
					Отмена
				</Button>
				<Button onClick={this.handleDescriptionPanelOk} type="primary">
					OK
				</Button>
			</div>
		);

		const df = record?.doneDate
			? dspxDiffDays(record?.doneDate, record?.createTime)
			: dspxDiffDays(0, record?.createTime);
		const bgf = "#d8f2ff";
		const fgf = "#0d6aa2";
		const tlf =
			"Время выполнения " +
			(df > 0 ? df + declOfNum(df, [" день", " дня", " дней"]) : "?");

		const dr = record?.doneDate
			? dspxDiffDays(record?.doneDate, record?.executeTime)
			: dspxDiffDays(0, record?.executeTime);

		//const bgr = dr > 14 ? '#ff4646' : '#d8f2ff';
		//const fgr = dr > 14 ? '#fff' : '#0d6aa2';
		const bgr = "#d8f2ff";
		const fgr = "#0d6aa2";
		const tlr =
			"Просрочено на " +
			(dr > 0
				? dr +
				  declOfNum(dr, [" день", " дня", " дней"]) +
				  (record?.executeTime ? "" : " / Нет даты назначения")
				: "?");

		const mi = this.state.statuses.map(
			(el) =>
				el.id !== record?.statusId && (
					<Menu.Item key={el.id} rid={record?.id}>
						<span>{el.description}</span>
					</Menu.Item>
				)
		);
		const menuItems =
			record?.garantyId === -999 // 0
				? [
						...mi,
						<Menu.Divider key="div1" />,
						<Menu.Item key={"pg"} rid={record?.id}>
							<PossWarrantyIcon
								style={{ height: "20px", verticalAlign: "text-bottom" }}
							/>
							<span>Возможно гарантия</span>
						</Menu.Item>,
				  ]
				: mi;
		const menu = (
			<Menu onClick={this.handleChangeStatusClick}>{menuItems}</Menu>
		);

		const wmenu = (
			<Menu onClick={this.handleChangeWarrantyClick}>
				<Menu.Item key={0} rid={record?.id}>
					Перевести в обычные
				</Menu.Item>
				<Menu.Item key={1} rid={record?.id}>
					Перевести в гарантийные
				</Menu.Item>
			</Menu>
		);

		const allowChangeExecuter =
			record?.statusId !== 3 && this.props.userInfo.CanChangeExecutors;

		return (
			<Spin spinning={this.props.dataFetching}>
				<Row>
					<Col span={3}>
						{record?.hasAttachment && (
							<span
								onClick={(e) => {
									e.stopPropagation();
								}}
							>
								<Popover
									visible={this.state.attachementPanelVisible == record?.id}
									onVisibleChange={this.handleAttachementPanelVisibleChange}
									content={
										<AttachmentsPanelContainer
											request={record?.id}
											hasattachment={record?.hasAttachment}
										/>
									}
									title={
										<div style={{ color: "#0995ed", fontSize: 18 }}>
											<Icon type="paper-clip" />
											<span> Вложения</span>
										</div>
									}
									//title={<div><span>Вложения</span><span style={{float:'right'}}><Icon type="file-add" onClick={()=>{}} /></span></div>}
									trigger="click"
								>
									<Tooltip mouseLeaveDelay={0} title="Вложения">
										<Button
											ghost
											shape="circle"
											style={{ top: "0px", left: "-10px" }}
											onClick={() => {
												this.handleAttachementClick(record?.id);
											}}
										>
											<AttachIcon
												grey={(!record?.hasAttachment).toString()}
												style={{ height: "18px" }}
											/>
										</Button>
									</Tooltip>
								</Popover>
							</span>
						)}
						{record?.byClient && (
							<span>
								<Tooltip mouseLeaveDelay={0} title="Из приложения">
									<UserMobileIcon
										style={{
											position: "relative",
											left: "-5px",
											top: "-5px",
											height: "24px",
										}}
									/>
								</Tooltip>
							</span>
						)}
						<span style={{ color: "#0995ed" }}>{record?.id}</span>
						<br />
						<Tooltip title={record?.ratingDescription}>
							<span onClick={this.handleRatingClick}>
								{record?.rating === "б/о" || (
									<Rate
										style={{ color: "#ccc", fontSize: 10 }}
										className={
											this.props.userInfo.CanSetRating && record?.statusId !== 3
												? "dspx-ref"
												: ""
										}
										disabled={
											!this.props.userInfo.CanSetRating || record?.statusId === 3
										}
										value={
											isNaN(record?.rating) ? 0 : parseInt(record?.rating, 10)
										}
										onChange={(e) =>
											this.handleRatingChange(
												e,
												record?.id,
												isNaN(record?.rating) ? 0 : parseInt(record?.rating, 10)
											)
										}
									/>
								)}
							</span>
						</Tooltip>
					</Col>
					<Col span={4}>
						<div>
							<span style={{ fontSize: "14px", marginRight: "10px" }}>
								{moment(record?.createTime).format("DD.MM.YYYY HH:mm")}
							</span>
							{!isNaN(df) && df !== 0 && record?.statusId != 4 && (
								<Tooltip title={tlf} mouseLeaveDelay={0}>
									<Badge
										count={df > 0 ? df : "?"}
										overflowCount={999999}
										title=" "
										style={{
											backgroundColor: bgf,
											color: fgf,
											top: "4px",
											cursor: "default",
										}}
									/>
								</Tooltip>
							)}
						</div>
						<div>
							{record?.garantyId === 2 && ( // 2
								<Dropdown overlay={wmenu} trigger={["click"]}>
									<Tooltip
										mouseLeaveDelay={0}
										title="Возможно гарантийная. Перевести в обычные/гарантийные"
									>
										<PossWarrantyIcon
											onClick={this.handleStateClick}
											style={{
												marginRight: "7px",
												height: "25px",
												cursor: "pointer",
											}}
										/>
									</Tooltip>
								</Dropdown>
							)}
							{record?.garantyId === 1 &&
								<Tooltip mouseLeaveDelay={0} title="Перевести в обычные">
									<Button rid={record.id} ghost shape="circle" style={{ fontSize: '10px', marginRight: '7px', height: '25px', minWidth: '25px' }}
								onClick={this.handleWarrantyClick}>
										<WarrantyIcon style={{ height: '100%' }} />
									</Button>
								</Tooltip>
							}
							<span
								onClick={(e) => {
									e.stopPropagation();
								}}
							>
								<Popover
									placement="right"
									content={
										<MarksPanel
											onChangeImmediate={(e) => {
												this.handleOnChangeImmediate(record?.id, e, record);
											}}
											onChangeChargeable={(e) => {
												this.handleOnChangeChargeable(record?.id, e);
											}}
											marks={{
												immediate: this.props.userInfo.CanChangeImmediate,
												chargeable: this.props.userInfo.CanChangeChargeable,
											}}
											marksValue={{
												immediate: record?.isImmediate,
												chargeable: record?.isChargeable,
											}}
										/>
									}
									title={
										<div>
											<Icon
												type="tag"
												style={{
													position: "relative",
													top: 3,
													fontSize: 20,
													color: "#ccc",
													marginRight: "7px",
													cursor: "pointer",
												}}
											/>{" "}
											Признаки
										</div>
									}
									trigger="click"
									visible={
										record?.statusId !== 3 &&
										(this.props.userInfo.CanChangeImmediate ||
											this.props.userInfo.CanChangeChargeable) &&
										this.state.marksPanelVisibleId == record?.id
									}
									onVisibleChange={(visible) => {
										this.handleMarksPanelVisibleChange(record?.id, visible);
									}}
								>
									{!record?.isRetry &&
										!record?.isImmediate &&
										!record?.isChargeable &&
										!record?.badWork &&
										record?.statusId !== 3 &&
										(this.props.userInfo.CanChangeImmediate ||
											this.props.userInfo.CanChangeChargeable) && (
											<Tooltip mouseLeaveDelay={0} title="Признаки">
												<Icon
													type="tag"
													style={{
														position: "relative",
														top: 5,
														fontSize: 20,
														color: "#ddd",
														marginRight: "7px",
														cursor: "pointer",
													}}
												/>
											</Tooltip>
										)}
									{record?.isRetry && (
										<Tooltip mouseLeaveDelay={0} title="Повторная">
											<RetryIcon
												style={{
													marginRight: "7px",
													height: "25px",
													cursor: "pointer",
												}}
											/>
										</Tooltip>
									)}
									{record?.isImmediate && (
										<Tooltip mouseLeaveDelay={0} title="Аварийная">
											<UrgentIcon
												style={{
													marginRight: "7px",
													height: "25px",
													cursor: "pointer",
												}}
											/>
										</Tooltip>
									)}
									{record?.isChargeable && (
										<Tooltip mouseLeaveDelay={0} title="Платная">
											<RubleIcon
												style={{
													marginRight: "7px",
													height: "25px",
													cursor: "pointer",
												}}
											/>
										</Tooltip>
									)}
									{record?.badWork && (
										<Tooltip mouseLeaveDelay={0} title="Для обсуждения">
											<BadWorkIcon
												style={{
													marginRight: "7px",
													height: "25px",
													cursor: "pointer",
												}}
											/>
										</Tooltip>
									)}
								</Popover>
							</span>
							{(this.props.userInfo.CanChangeStatus &&
								record?.statusId !== 3 && (
									<Dropdown overlay={menu} trigger={["click"]}>
										<Tooltip
											mouseEnterDelay={0.6}
											mouseLeaveDelay={0}
											title="Изменить статус"
										>
											<span
												className={"dspx-ref"}
												onClick={this.handleStateClick}
												style={{
													fontSize: "11px",
													cursor: "pointer",
													color: "#0995ed",
												}}
											>
												{record?.status}
											</span>
										</Tooltip>
									</Dropdown>
								)) || (
								<span style={{ fontSize: "11px", color: "#0995ed" }}>
									{record?.status}
								</span>
							)}
						</div>
					</Col>

					<Col span={4}>
						<div>
							<div style={{ fontSize: "13px" }}>
								<span
									onClick={
										record?.statusId === 3 ||
										!this.props.userInfo.CanChangeAddress
											? null
											: (tar) => {
													tar.stopPropagation();
													this.handleAddressClick(record);
											  }
									}
									className={
										record?.statusId === 3 ||
										!this.props.userInfo.CanChangeAddress
											? ""
											: "dspx-ref"
									}
									style={{
										fontSize: "12px",
										marginRight: "10px",
										whiteSpace: "nowrap",
										cursor:
											record?.statusId === 3 ||
											!this.props.userInfo.CanChangeAddress
												? "default"
												: "pointer",
									}}
								>
									{record?.fullAddress}
								</span>
							</div>
							{(record?.entrance || record?.floor) && (
								<div
									style={{
										fontSize: "12px",
										color: "#888",
										whiteSpace: "nowrap",
									}}
								>
									{record?.entrance && ` подъезд: ${record?.entrance} `}
									{record?.floor && `этаж: ${record?.floor}`}
								</div>
							)}
							{record?.regionName && (
								<div
									style={{
										fontSize: "12px",
										color: "#8e8e8e",
										whiteSpace: "nowrap",
									}}
								>
									{`мкр. ${record?.regionName}`}
								</div>
							)}
						</div>
					</Col>

					<Col span={5}>
						<div>
							<div
								style={{
									color: "#17a9f1",
									fontSize: "13px",
									fontWeight: "500",
								}}
							>
								<Tooltip title="Услуга" mouseLeaveDelay={0}>
									<span
										onClick={
											record?.statusId === 3 ||
											!this.props.userInfo.CanChangeServiceType
												? null
												: (tar) => {
														tar.stopPropagation();
														this.handleAddressClick(record, true);
												  }
										}
										className={
											record?.statusId === 3 ||
											!this.props.userInfo.CanChangeServiceType
												? ""
												: "dspx-ref"
										}
										style={{
											marginRight: "10px",
											whiteSpace: "nowrap",
											cursor:
												record?.statusId === 3 ||
												!this.props.userInfo.CanChangeServiceType
													? "default"
													: "pointer",
										}}
									>
										{record?.parentService}
									</span>
								</Tooltip>
							</div>
							<div>
								<Tooltip title="Причина" mouseLeaveDelay={0}>
									<span
										rid={record?.id}
										parent_service={record?.parentService}
										parent_service_id={record?.parentServiceId}
										service_id={record?.serviceId}
										house_id={record?.houseId}
										onClick={
											record?.statusId === 3 &&
											this.props.userInfo.CanChangeServiceType
												? null
												: this.handleServiceClick
										}
										className={
											record?.statusId === 3 &&
											this.props.userInfo.CanChangeServiceType
												? ""
												: "dspx-ref"
										}
										style={{
											fontSize: "12px",
											marginRight: "10px",
											whiteSpace: "nowrap",
											cursor:
												record?.statusId === 3 &&
												this.props.userInfo.CanChangeServiceType
													? "default"
													: "pointer",
										}}
									>
										{(record?.service && record?.service) || "не указана"}
									</span>
								</Tooltip>
							</div>
						</div>
					</Col>

					<Col span={4}>
						<div>
							<span>
								<Tooltip title="Назначено" mouseLeaveDelay={0}>
									<span
										rid={record?.id}
										onClick={
											this.props.userInfo.CanChangeExecuteDate &&
											record?.statusId !== 3
												? this.handleExecuteDateClick
												: null
										}
										style={{
											fontSize: "12px",
											marginRight: "10px",
											whiteSpace: "nowrap",
											cursor:
												this.props.userInfo.CanChangeExecuteDate &&
												record?.statusId !== 3
													? "pointer"
													: "default",
										}}
									>
										<svg
											style={{ color: "#aaa", marginRight: "8px" }}
											className="icon icon-history"
										>
											<use xlinkHref="#icon-history"></use>
										</svg>
										<span
											rid={record?.id}
											className={
												this.props.userInfo.CanChangeExecuteDate &&
												record?.statusId !== 3
													? "dspx-ref"
													: ""
											}
										>
											{(record?.executeTime &&
												moment(record?.executeTime).format(
													"DD.MM.YYYY HH:mm"
												)) ||
												"нет"}
										</span>
									</span>
								</Tooltip>

								{(record?.taskId ||
									(record?.statusId !== 3 && record?.executer)) && (
									<Tooltip
										title={
											(record?.taskId &&
												moment(record?.taskStart).format("DD.MM.YYYY HH:mm") +
													moment(record?.taskEnd).format(" - HH:mm")) ||
											"добавить в календарь"
										}
										mouseLeaveDelay={0}
									>
										<span
											className={record?.statusId === 3 ? "" : "dspx-ref-hidden"}
											onClick={
												record?.statusId === 3 || !record?.executer
													? null
													: (val) => {
															this.handleCalendarClick(val, {
																rid: record?.id,
																eid: record?.executer.id,
																cid: record?.taskId,
																start: record?.taskStart,
																end: record?.taskEnd,
															});
													  }
											}
											style={{
												marginRight: "0px",
												whiteSpace: "nowrap",
												cursor:
													record?.statusId === 3 && record?.executer
														? "default"
														: "pointer",
											}}
										>
											<Icon
												type="calendar"
												style={{
													color: record?.taskId ? "#ff921e" : "#aaa",
													marginRight: "8px",
												}}
											/>
										</span>
									</Tooltip>
								)}

								{!isNaN(dr) && dr > 0 && record?.statusId != 4 && (
									<Tooltip title={tlr} mouseLeaveDelay={0}>
										<Badge
											count={
												<Icon
													type="fire"
													theme="twoTone"
													style={{ fontSize: 20 }}
													twoToneColor={dr > 14 ? "#ff0003" : "#f44336"}
												/>
											}
										>
											<Badge
												count={dr > 0 ? dr : "?"}
												overflowCount={999999}
												title=" "
												style={{
													backgroundColor: bgr,
													color: fgr,
													top: "4px",
													cursor: "default",
												}}
											/>
										</Badge>
									</Tooltip>
								)}
								{record?.doneDate && (
									<Tooltip title="Подтверждено" mouseLeaveDelay={0}>
										<div
											style={{
												fontSize: "12px",
												marginRight: "10px",
												color: "#0995ed",
												whiteSpace: "nowrap",
											}}
										>
											<svg
												style={{ color: "#aaa", marginRight: "8px" }}
												className="icon icon-clipboard"
											>
												<use xlinkHref="#icon-clipboard"></use>
											</svg>
											{record?.doneDate &&
												moment(record?.doneDate).format("DD.MM.YYYY HH:mm")}
										</div>
									</Tooltip>
								)}
								{/*
					<div style={{ fontSize: '11px' }}>
						{record?.executePeriod}
					</div> */}
							</span>
						</div>
					</Col>
					<Col span={4}>
						<div>
							<div>
								<Tooltip
									mouseEnterDelay={0.6}
									mouseLeaveDelay={0}
									title={allowChangeExecuter ? "Назначить мастера" : "Мастер"}
								>
									<span
										onClick={
											allowChangeExecuter ? (e) => {this.handleMasterClick(e, record)} : null
										}
										className={allowChangeExecuter ? "dspx-ref" : ""}
										style={{
											fontWeight: "400",
											fontSize: "13px",
											whiteSpace: "nowrap",
											color: "#888888",
											cursor: allowChangeExecuter ? "pointer" : "default",
										}}
									>
										{(record?.master && record?.master.fullName) || (
											<span
												rid={record?.id}
												bid={record?.houseId}
												sid={record?.serviceId}
												style={{ color: "#b1b1b1" }}
											>
												не назначен
											</span>
										)}
									</span>
								</Tooltip>
							</div>

							<div>
								<Tooltip
									mouseEnterDelay={0.6}
									mouseLeaveDelay={0}
									title={
										allowChangeExecuter
											? "Назначить исполнителя"
											: "Исполнитель"
									}
								>
									<span
										onClick={
											allowChangeExecuter ? (e)=>{this.handleExecuterClick(e, record)} : null
										}
										className={allowChangeExecuter ? "dspx-ref" : ""}
										style={{
											fontSize: "13px",
											whiteSpace: "nowrap",
											color: "#0995ed",
											cursor: allowChangeExecuter ? "pointer" : "default",
										}}
									>
										{(record?.executer && record?.executer.fullName) || (
											<span
												rid={record?.id}
												bid={record?.houseId}
												sid={record?.serviceId}
												style={{ color: "#9bccc7" }}
											>
												не назначен
											</span>
										)}
									</span>
								</Tooltip>
							</div>
							{record?.companyName && (
								<div style={{ fontSize: "11px", color: "#009fdc" }}>
									{record?.companyName}
								</div>
							)}
						</div>
					</Col>
				</Row>
				<Row>
					<div
						className="dspx-query-detail"
						style={{ margin: "0px 0px 0px 40px" }}
					>
						<Row gutter={16}>
							<Col span={1}>
								{record?.hasRecord && (
									<Popover
										content={<RecordsPanelContainer request={record?.id} />}
										title={
											<div style={{ color: "#0995ed", fontSize: 18 }}>
												<Icon type="phone" />
												<span> Звонки</span>
											</div>
										}
										trigger="click"
										placement="top"
									>
										<Tooltip mouseLeaveDelay={0} title="Звонки">
											<Button
												ghost
												shape="circle"
												style={{ fontSize: "10px", marginTop: "0px" }}
											>
												<RecordIcon
													style={{ height: "20px", marginTop: "0px" }}
												/>
											</Button>
										</Tooltip>
									</Popover>
								)}
								{!record?.hasAttachment && (
									<Popover
										visible={this.state.attachementPanelVisible == record?.id}
										onVisibleChange={this.handleAttachementPanelVisibleChange}
										content={
											<AttachmentsPanelContainer
												request={record?.id}
												hasattachment={record?.hasAttachment}
											/>
										}
										title={
											<div style={{ color: "#0995ed", fontSize: 18 }}>
												<Icon type="paper-clip" />
												<span> Вложения</span>
											</div>
										}
										//title={<div><span>Вложения</span><span style={{float:'right'}}><Icon type="file-add" onClick={()=>{}} /></span></div>}
										trigger="click"
									>
										<Tooltip mouseLeaveDelay={0} title="Добавить вложения">
											<Button
												ghost
												shape="circle"
												style={{ fontSize: "10px", marginTop: "5px" }}
												onClick={() => {
													this.handleAttachementClick(record?.id);
												}}
											>
												<AttachIcon
													grey={(!record?.hasAttachment).toString()}
													style={{ height: "20px", marginTop: "0px" }}
												/>
											</Button>
										</Tooltip>
									</Popover>
								)}

								{record?.garantyId === 0 &&
									record?.statusId !== 3 && ( //
										<Tooltip
											mouseLeaveDelay={0}
											title="Перевести в возможно гарантийные"
										>
											<Button rid={record.id} ghost shape="circle" style={{ fontSize: '10px', marginTop: '5px' }} onClick={this.handlePossWarrantyClick}>
												<PossWarrantyIcon grey='true' style={{ height: '20px', marginTop: '0px' }} />
											</Button>
										</Tooltip>
									)}
							</Col>
							<Col span={7}>
								<div style={{ fontSize: "13px" }}>
									{record?.createUser && (
										<div>
											<Icon
												type="solution"
												style={{
													fontSize: "16px",
													color: "#bbb",
													marginRight: "4px",
												}}
											/>
											{record?.createUser.fullName}
										</div>
									)}
									{record?.contactPhones && (
										<div>
											<Icon
												type="phone"
												style={{
													fontSize: "16px",
													color: "#bbb",
													marginRight: "4px",
													marginTop: "8px",
												}}
											/>{" "}
											{record?.contactPhones}
											{record?.clientName && (
												<Icon
													type="user"
													style={{
														fontSize: "16px",
														color: "#bbb",
														marginRight: "4px",
														marginLeft: "8px",
														marginTop: "8px",
													}}
												/>
											)}{" "}
											{record?.clientName}
										</div>
									)}

									<div>
										<Icon type="file-text" style={{ marginRight: "4px" }} />
										{record?.service} : {record?.description}
										{record?.statusId !== 3 &&
											this.props.userInfo.CanChangeDescription && (
												<Popover
													placement="right"
													content={DescriptionPanel}
													title={
														<div style={{ color: "#0995ed", fontSize: 18 }}>
															<Icon type="file-text" />
															<span> Описание</span>
														</div>
													}
													trigger="click"
													visible={
														this.state.descriptionPanelVisibleId == record?.id
													}
													onVisibleChange={(visible) => {
														this.handleDescriptionPanelVisibleChange(
															record?.id,
															record?.description,
															visible
														);
													}}
												>
													<Tooltip
														mouseLeaveDelay={0}
														title="Редактировать описание"
													>
														<Button
															ghost
															size="small"
															shape="circle"
															style={{ marginLeft: 2, fontSize: "10px" }}
														>
															<Icon type="edit" style={{ margin: 0 }} />
														</Button>
													</Tooltip>
												</Popover>
											)}{" "}
									</div>
								</div>
							</Col>
							<Col span={7}>
								<NotesPanelContainer
									request={record?.id}
									isnotes={record?.existNote}

									onPostComment={ 
										(record?.statusId !== 3 && !record?.existNote) 
												? rid=>{ this.handlePostComment(rid) } : null }
								/>
							</Col>
							<Col span={9}>
								{record?.garantyId === 1 && (
									<WarrantyPanel requestId={record?.id} />
								)}
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={12}></Col>
							<Col span={12}></Col>
						</Row>
					</div>
				</Row>
			</Spin>
		);
	}
}

function mapStateToProps(state) {
	const { requestStore } = state;
	//const requests = state.requestsStore.requests;
	const { requests, showPreview, showModal, dataFetching } = state.requestsStore;
	const executers = state.requestsStore.filterExecuter;
	const { userInfo } = state.authentication;

	return {
		...requestStore,
		requests,
		executers,
		userInfo,
		showPreview,
		showModal,
		dataFetching,
	};
}

export default connect(mapStateToProps)(DspxRequest);
